import localStorageUtil from '../../../utils/storage/localStorage';
import type { JWTPayload, LiviaStorage } from '../types';
import { STORAGE_KEYS } from '../config';

export interface TokenStorageManager {
  getStorage(): LiviaStorage | null;
  skipRefreshToken(): boolean;
  isExpired(token: string): boolean;
  updateTokens(accessToken: string, refreshToken: string): void;
  clearStorage(): void;
}

export const tokenStorageManager = (): TokenStorageManager => {
  const getStorage = () => {
    return localStorageUtil.get<LiviaStorage>(STORAGE_KEYS.AUTH_DATA).value
  };

  const isExpired = (token: string): boolean => {
    try {
      const parts = token.split(".");
      if (parts.length !== 3) { return true; }

      const payloadBase64 = parts[1];
      const payloadJson = atob(payloadBase64);
      const payload: JWTPayload = JSON.parse(payloadJson);

      const expired = Date.now() >= payload.exp * 1000;
      return expired;
    } catch {
      return true;
    }
  };

  const skipRefreshToken = () => {
    const storage = getStorage()
    return !storage?.token || !isExpired(storage?.token);

  }

  const updateTokens = (accessToken: string, refreshToken: string): void => {
    const current = getStorage();
    if (!current) return;
    localStorageUtil.set(STORAGE_KEYS.AUTH_DATA, {
      ...current,
      token: accessToken,
      refreshToken: refreshToken
    })
  };

  const clearStorage = (): void => {
    localStorageUtil.remove([STORAGE_KEYS.AUTH_DATA, STORAGE_KEYS.KEEP_LOGGED])
  };

  return {
    getStorage,
    updateTokens,
    clearStorage,
    isExpired,
    skipRefreshToken
  };
};
